import {
  Card,
  CardBody,
  CardHeader,
  Flex,
  Text,
  Heading,
  Button,
} from '@chakra-ui/react';
import { BarsProgressDuotone } from './icons/bars-progress-duotone';
import AiSuggestions from 'components/ai-suggestions/ai-suggestions';
import * as analytics from 'utils/analytics';
import { useState } from 'react';

export const AiSuggestionsCard = () => {
  const [isEnabled, setIsEnabled] = useState(false);
  return (
    <Card w='100%' flexShrink={0}>
      <CardHeader>
        <Heading size='sm'>
          <Flex gap={2} alignItems='center'>
            <BarsProgressDuotone />
            <Text>3 AI generated LinkedIn posts for you</Text>
          </Flex>
        </Heading>
      </CardHeader>
      <CardBody>
        {!isEnabled && (
          <Flex justifyContent='center'>
            <Button
              mb={9}
              variant='secondary'
              onClick={() => {
                analytics.log('dashboard_ai_post_generated');
                setIsEnabled(true);
              }}
            >
              Get suggestions
            </Button>
          </Flex>
        )}
        {isEnabled && (
          <AiSuggestions suggestionsCount={3} showOriginals={false} dense />
        )}
      </CardBody>
    </Card>
  );
};
